import api from 'helpers/api';
import { toast } from 'sonner';
import authHeader from '../helpers/auth-headers';

class PluginService {
  async getPlugins() {
    try {
      const response = await api.get('/api/v2/plugins', { headers: authHeader() });
      return response.data.plugins;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting plugins' });
      return [];
    }
  }

  async uploadPlugin(formData) {
    try {
      const response = await api.post('/api/v2/plugins', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...authHeader()
        }
      });
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error uploading plugin' });
      return { status: 'Failed' };
    }
  }

  async executePlugin(pluginName) {
    try {
      const response = await api.post(
        '/api/v2/plugins/execute',
        { pluginName: pluginName },
        {
          headers: {
            ...authHeader()
          }
        }
      );
      return { status: 'Success', message: response.data.message };
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error executing plugin' });
      return { status: 'Failed' };
    }
  }
}

export default new PluginService();
